import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableItem = ({
  className,
  children,
  id,
}: {
  className: any;
  children: any;
  id: any;
}) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    position: 'relative',
    opacity: isDragging ? 0.5 : undefined,
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <div className={className} ref={setNodeRef} style={style} {...attributes}>
      {children({ listeners })}
    </div>
  );
};

export default React.memo(SortableItem) as any;
